"use client";
import { useEffect, useState } from "react";

import { useFlags, useLDClient } from "@stadium/services/launch-darkly/library-imports";

const FeatureFlagWrapper = ({
  flag,
  onMount = null,
  fallback = null,
  children = null,
  flags = [],
  evaluateAndCondition = true,
  loader = fallback,
}) => {
  const evaluatedFlags = useFlags();
  const ldClient = useLDClient();
  const [isReady, setIsReady] = useState(false);

  const { [flag]: selectedFlag } = evaluatedFlags;

  const showContent = (() => {
    if (flag) {
      return selectedFlag;
    }
    if (flags?.length) {
      const methodApplied = evaluateAndCondition ? "every" : "some";
      return flags[methodApplied]((featureFlag) => evaluatedFlags[featureFlag]);
    }
  })();

  useEffect(() => {
    if (ldClient) {
      ldClient.waitUntilReady().finally(() => setIsReady(true));
    }
  }, [ldClient]);

  useEffect(() => {
    if (isReady) {
      onMount?.(showContent);
    }
  }, [isReady]);

  const renderContent = (content, ...args) =>
    typeof content === "function" ? content(...args) : content;

  if (!isReady) {
    return renderContent(loader);
  }

  return showContent ? children : renderContent(fallback);
};

export default FeatureFlagWrapper;
